export default __webpack_public_path__ + "static/media/instagram.eec9a27a.svg";